import { useRef } from "react";
import { useElementOnScreen } from "../hooks";
import React from "react";

export function AnimatedSection({ fade, children, disableAnimation }) {
  const ref = useRef(null);
  const onScreen = useElementOnScreen(ref);

  const DefaultStyles = disableAnimation
    ? {}
    : {
        opacity: onScreen ? 1 : 0,
        transform: onScreen ? "none" : "translateY(2rem)",
        transition: "600ms ease-in-out",
      };

  const FadeInStyles = disableAnimation
    ? {}
    : {
        opacity: onScreen ? 1 : 0.7,
        transition: "600ms ease-in-out",
      };

  return (
    <div ref={ref} style={fade ? FadeInStyles : DefaultStyles}>
      {children}
    </div>
  );
}
